import Cell from '../Cell';
import { defineComponent } from 'vue';
import { useInjectTable } from '../context/TableContext';
import { useInjectExpandedRow } from '../context/ExpandedRowContext';
export default defineComponent({
    name: 'ExpandedRow',
    inheritAttrs: false,
    props: ['prefixCls', 'component', 'cellComponent', 'expanded', 'colSpan', 'isEmpty'],
    setup(props, { slots, attrs }) {
        const tableContext = useInjectTable();
        const expandedRowContext = useInjectExpandedRow();
        const { fixHeader, fixColumn, componentWidth, horizonScroll } = expandedRowContext;
        return () => {
            const { prefixCls, component: Component, cellComponent, expanded, colSpan, isEmpty } = props;
            return (<Component class={attrs.class} style={{
                    display: expanded ? null : 'none',
                }}>
          <Cell component={cellComponent} prefixCls={prefixCls} colSpan={colSpan} v-slots={{
                    default: () => {
                        var _a;
                        let contentNode = (_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots);
                        if (isEmpty ? horizonScroll.value : fixColumn.value) {
                            contentNode = (<div style={{
                                    width: `${componentWidth.value - (fixHeader.value ? tableContext.scrollbarSize : 0)}px`,
                                    position: 'sticky',
                                    left: 0,
                                    overflow: 'hidden',
                                }} class={`${prefixCls}-expanded-row-fixed`}>
                      {contentNode}
                    </div>);
                        }
                        return contentNode;
                    },
                }}></Cell>
        </Component>);
        };
    },
});
